import React from 'react';
import { useIntl } from 'react-intl';
import { Upload, UploadLbis } from 'ui';

const FileUploadPart = ({
  title,
  onChange,
  isRequired,
  fileCount,
}: {
  title: string;
  onChange: any;
  isRequired: boolean;
  fileCount?: number;
}) => {
  const intl = useIntl();
  return (
    <div className="upload">
      <span className={`${isRequired && 'fake-required'}`}>{title}</span>
      <div className="upload_btn">
        <UploadLbis
          customRequest={() => false}
          onChange={(info) => onChange(info)}
          showUploadList={false}
          fileList={[]}
          geoClassifer={true}
        >
          <span>
            {fileCount
              ? intl.formatMessage({ id: 'general.upload_more' })
              : intl.formatMessage({ id: 'general.upload' })}
          </span>
        </UploadLbis>
      </div>
    </div>
  );
};

export default FileUploadPart;
